/**
 * Utility functions for group-related operations
 */

import {
  Groups as GroupsIcon,
  Business as BusinessIcon,
  Cloud as CloudIcon,
  Person as PersonIcon,
  AdminPanelSettings as AdminIcon,
  Visibility as ViewIcon,
} from '@mui/icons-material';

type ChipColor = "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";

export const getSourceIcon = (source: string) => {
  switch (source) {
    case 'local': return BusinessIcon;
    case 'entra': return CloudIcon;
    case 'google': return CloudIcon;
    case 'okta': return CloudIcon;
    default: return GroupsIcon;
  }
};

export const getSourceColor = (source: string): ChipColor => {
  switch (source) {
    case 'local': return 'primary';
    case 'entra': return 'info';
    case 'google': return 'success';
    case 'okta': return 'warning';
    default: return 'default';
  }
};

export const getRoleIcon = (role: string) => {
  switch (role.toLowerCase()) {
    case 'admin': return AdminIcon;
    case 'member': return PersonIcon;
    case 'viewer': return ViewIcon;
    default: return PersonIcon;
  }
};

export const getRoleColor = (role: string): ChipColor => {
  switch (role.toLowerCase()) {
    case 'admin': return 'error';
    case 'member': return 'primary';
    case 'viewer': return 'info';
    default: return 'default';
  }
};

export const formatGroupType = (type: string): string => {
  return (type || 'custom').charAt(0).toUpperCase() + (type || 'custom').slice(1);
};